import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FertilizerMasterList from "../components/FertilizerMasterList";

const FertilizerMasterPage = () => {
  return (
    <>
      <Breadcrumb title="Fertilizer Master" />
      <FertilizerMasterList />
    </>
  );
};

export default FertilizerMasterPage;
